<template>
  <v-layout justify-space-between wrap>
    <v-layout wrap>
      <v-btn @click="prev" :aria-label="'Show calendar for previous month, ' + prevMonth">
        <v-icon left aria-hidden="true">keyboard_arrow_left</v-icon>
        {{prevMonth}}
      </v-btn>
      <v-btn @click="next" :aria-label="'Show calendar for next month, ' + nextMonth">
        {{nextMonth}}
        <v-icon right aria-hidden="true">keyboard_arrow_right</v-icon>
      </v-btn>
    </v-layout>
    <ExportButton ref="exportbutton"></ExportButton>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import ExportButton from '@/components/ExportButton'

  export default {
    components: {
      ExportButton
    },
    props: ['results'],
    computed: {
      month: {
        get () { return this.$store.state.details.month },
        set (value) { this.$store.commit('setDetails', { filter: 'month', value })}
      },
      year: {
        get () { return this.$store.state.details.year },
        set (value) { this.$store.commit('setDetails', { filter: 'year', value })}
      },
      prevMonth () { return moment().month(this.month-1).subtract(1, 'months').format('MMMM') },
      nextMonth () { return moment().month(this.month-1).add(1, 'months').format('MMMM') }
    },
    methods: {
      prev () {
        const newDate = moment().month(this.month-1).year(this.year).subtract(1, 'months')
        this.year = newDate.format('YYYY')
        this.month = newDate.format('M')
        this.$emit('change')
      },
      next () {
        const newDate = moment().month(this.month-1).year(this.year).add(1, 'months')
        this.month = newDate.format('M')
        this.year = newDate.format('YYYY')
        this.$emit('change')
      }
    }
  }
</script>